// Dumb card array — no store, no SQL. The page owns useItemTotals and performs
// the showOpenItemsOnly reload cycle.
//
//   props:  dataLoaded                (Boolean) shows skeletons while false
//           totalItems                (Number)
//           totalSubItems             (Number)
//           totalAssignedToYourTeams  (Number)
//           totalAssignedToYou        (Number)
//           showOpenItemsOnly         (Boolean) v-model of the select card
//           filterByMyTeams           (Boolean) v-model of the teams switch
//           filterByMe                (Boolean) v-model of the "me" switch
//           sparklines                (Object|null) OPT-IN, default null — the SPARK ROW
//                                     (issue-analysis, IA_ABSORPTION_PLAN Phase 4 step 13):
//                                     { totalItems, totalAssignedToYourTeams, totalAssignedToYou },
//                                     each { data: number[], labels: string[],
//                                     percentageChange: number|null }. Set, the row is three spark
//                                     cards (TotalSparkCard "Total" + two TotalSparkCardWithSwitch,
//                                     md=4) — no sub-items card, no open-items select, so
//                                     totalSubItems/showOpenItemsOnly are not read. Null, the v-else
//                                     row renders, exactly as before.
//   emits:  filterChange({ id, selected })  id is 'totalAssignedToYourTeams'
//                                           or 'totalAssignedToYou'
//           update:showOpenItemsOnly        triggers the page's full reload (R4)
//           update:filterByMyTeams, update:filterByMe
// The three cards are siblings in this package — imported relatively, never through the
// package's own name (which would also be a barrel cycle now that this card array is exported).
import TotalCard from '../TotalCard/component.vue';
import TotalCardWithSelect from '../TotalCardWithSelect/component.vue';
import TotalCardWithSwitch from '../TotalCardWithSwitch/component.vue';
import TotalSparkCard from '../TotalSparkCard/component.vue';
import TotalSparkCardWithSwitch from '../TotalSparkCardWithSwitch/component.vue';
import setup from './setup.js';

export default {
  name: 'total-and-assigned-cards',
  props: {
    dataLoaded: {
      type: Boolean,
      default: false
    },
    totalItems: {
      type: Number,
      default: 0
    },
    totalSubItems: {
      type: Number,
      default: 0
    },
    totalAssignedToYourTeams: {
      type: Number,
      default: 0
    },
    totalAssignedToYou: {
      type: Number,
      default: 0
    },
    showOpenItemsOnly: {
      type: Boolean,
      default: false
    },
    filterByMyTeams: {
      type: Boolean,
      default: false
    },
    filterByMe: {
      type: Boolean,
      default: false
    },
    sparklines: {
      type: Object,
      default: null
    }
  },
  emits: [
    'filterChange',
    'update:showOpenItemsOnly',
    'update:filterByMyTeams',
    'update:filterByMe'
  ],
  components: { TotalCard, TotalCardWithSelect, TotalCardWithSwitch, TotalSparkCard, TotalSparkCardWithSwitch },
  setup,
};
